import React from 'react';
import './App.css';
import CleanNestWebsite from './components/CleanNestWebsite';

function App() {
  return <CleanNestWebsite />;
}

export default App;